import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TranslationService } from './../../services/translation.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  standalone: false
})
export class CalendarComponent implements OnInit, AfterViewInit {
  constructor(private translationService: TranslationService) {}

  isMobileView = false;
  translations?: any;

  ngOnInit() {
    this.isMobileView = window.innerWidth < 768;
    this.translationService.getTranslations().subscribe((translations) => {
      this.translations = translations;
    });
  }

  ngAfterViewInit(): void {
    const existingScript = document.getElementById('zcal-script');
    const config = {
      url: 'https://zcal.co/i/sPGFL-KM',
      mode: 'inline',
      theme: 'dark',
      hideEventTypeDetails: !this.isMobileView,
      color: {
        accentColor: '#5e17eb',
        buttonTextColor: '#ffffff',
        buttonBackgroundColor: '#5e17eb'
      }
    };

    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'zcal-script';
      script.src = 'https://static.zcal.co/embed/v1/embed.js';
      script.async = true;
      script.onload = () => {
        // @ts-ignore
        window.zcal?.init('#zcal-embed', config);
      };
      document.body.appendChild(script);
    } else {
      // @ts-ignore
      window.zcal?.init('#zcal-embed', config);
    }
  }
}
